module.exports = __webpack_public_path__ + "static/img/domainLogo.bce631d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/oneashley/domainLogo.png
// module id = a2zo
// module chunks = 1